import React from 'react'
import ReactDOM from 'react-dom'
// import registerServiceWorker from './registerServiceWorker';

import { connectedRouterRedirect } from 'redux-auth-wrapper/history4/redirect'
import locationHelperBuilder from 'redux-auth-wrapper/history4/locationHelper'

import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import { createStore, applyMiddleware, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'
import { Provider } from 'react-redux'
// import {UserAuthWrapper} from 'redux-auth-wrapper'


// eslint-disable-next-line
import Bootstrap from 'bootstrap/dist/css/bootstrap.css'

// AdminLTE related css
import './static/css/_all-skins.css'

import './static/css/AdminLTE-bootstrap-social.css'
import './static/css/AdminLTE-fullcalendar.css'
import './static/css/AdminLTE-select2.css'
import './static/css/font-awesome.css'
import './static/css/ionicons.css'

import './static/css/custom_bootstrap.css'
import './static/css/custom_adminlte.css'
import './static/css/AdminLTE.css'


import DevTools from './helpers//dev_tools'
// import { Dashboard } from './components/Dashboard'
// import { Login } from './components/Login'
// import asyncComponent from "./async_component"
import Loadable from 'react-loadable'

import appReducer from './reducer'

// const Login = asyncComponent(() => import('./components/Login/Login'));
// const Dashboard = asyncComponent(() => import('./components/Dashboard/Dashboard'));

const Login = Loadable({
  loader: () => import('./components/login/login'),
  loading: () => null,
})
const Dashboard = Loadable({
  loader: () => import('./components/dashboard'),
  loading: () => null,
})
const Signup = Loadable({
  loader: () => import('./components/login/signup'),
  loading: () => null,
})
const LiveChats = Loadable({
  loader: () => import('./components/chats'),
  loading: () => null,
})
const LiveVisitors = Loadable({
  loader: () => import('./components/visitors'),
  loading: () => null,
})
const ChatReports = Loadable({
  loader: () => import('./components/chat_reports'),
  loading: () => null,
})
const LabsUsers = Loadable({
  loader: () => import('./components/lab_users'),
  loading: () => null,
})
const KintegraUsers = Loadable({
  loader: () => import('./components/app_users'),
  loading: () => null,
})
const SsoLogin = Loadable({
  loader: () => import('./components/sso_login'),
  loading: () => null,
})

const individualUserInfo = Loadable({
  loader: () => import('./components/individual_user_info/individual_user_info'),
  loading: () => null,
})

const ClearoutIndividualUserInfo = Loadable({
  loader: () => import('./components/individual_user_info/clearout_individual_user_info'),
  loading: () => null,
})

const CopIndividualUserInfo = Loadable({
  loader: () => import('./components/cop_individual_user_info/cop_individual_user_info'),
  loading: () => null,
})

const ClearoutIndividualUserActivity = Loadable({
  loader: () => import('./components/individual_user_info/user_activity'),
  loading: () => null,
})

const CopIndividualUserActivity = Loadable({
  loader: () => import('./components/cop_individual_user_info/user_activity'),
  loading: () => null,
})

const SpokeslyIndividualUserActivity = Loadable({
  loader: () => import('./components/spokesly_individual_user_info/user_activity'),
  loading: () => null,
})

const ClearoutOrganizationInfo = Loadable({
  loader: () => import('./components/individual_user_info/clearout_organization_info'),
  loading: () => null,
})
const SpokeslyOrganizationInfo = Loadable({
  loader: () => import('./components/spokesly_individual_user_info/spokesly_organization_info'),
  loading: () => null,
})

const ClearoutUsersList = Loadable({
  loader: () => import('./components/clearout_users'),
  loading: () => null,
})

const SpokeslyOrganizationUsersList = Loadable({
  loader: () => import('./components/spokesly_users/spokesly_organization_users'),
  loading: () => null,
})

const ClearoutOrganizationUsersList = Loadable({
  loader: () => import('./components/clearout_users/clearout_organization_users'),
  loading: () => null,
})

const ClearoutEUOrganizationUsersList = Loadable({
  loader: () => import('./components/clearout_eu_users/clearout_eu_organization_users'),
  loading: () => null,
})

const ClearoutEPOrganizationUsersList = Loadable({
  loader: () => import('./components/clearout_ep_users/clearout_ep_organization_users'),
  loading: () => null,
})

const DownloadClearoutUsersList = Loadable({
  loader: () => import('./components/clearout_users/clearout_allusers_download'),
  loading: () => null,
})

const ClearoutPhoneUsersList = Loadable({
  loader: () => import('./components/clearout_phone_users'),
  loading: () => null,
})
const DownloadClearoutPhoneUsersList = Loadable({
  loader: () => import('./components/clearout_phone_users/clearout_phone_all_users_download'),
  loading: () => null,
})

const Download = Loadable({
  loader: () => import(/* webpackChunkName: "Download" */
    './components/download/download'),
  loading: function Loading() {
    return <div id='react-loadable' className='react-loadable-loading' >Downloading...</div>
  }
})

const CopDownload = Loadable({
  loader: () => import(/* webpackChunkName: "Download" */
    './components/cop_download/download'),
  loading: function Loading() {
    return <div id='react-loadable' className='react-loadable-loading' >Downloading...</div>
  }
})

const DownloadWithoutPolling = Loadable({
  loader: () => import(/* webpackChunkName: "DownloadWithoutPolling" */
    './components/download/downloadWithoutPolling'),
  loading: function Loading() {
    return <div id='react-loadable' className='react-loadable-loading' >Downloading...</div>
  }
})
const CopDownloadWithoutPolling = Loadable({
  loader: () => import(/* webpackChunkName: "DownloadWithoutPolling" */
    './components/cop_download/downloadWithoutPolling'),
  loading: function Loading() {
    return <div id='react-loadable' className='react-loadable-loading' >Downloading...</div>
  }
})

const RequestList = Loadable({
  loader: () => import('./components/request_list'),
  loading: () => null,
})

const ClearoutLists = Loadable({
  loader: () => import(/* webpackChunkName: "ClearoutLists" */
    './components/clearout_lists/myList'),
  loading: function Loading() {
    return <div id='react-loadable' className='react-loadable-loading' >Loading...</div>
  }
})

const ClearoutEmailFinderLists = Loadable({
  loader: () => import(/* webpackChunkName: "ClearoutEmailFinderLists" */
    './components/clearout_emailfinder_lists/myList'),
  loading: function Loading() {
    return <div id='react-loadable' className='react-loadable-loading' >Loading...</div>
  }
})

const CopLists = Loadable({
  loader: () => import(/* webpackChunkName: "CopLists" */
    './components/cop_lists/myList'),
  loading: function Loading() {
    return <div id='react-loadable' className='react-loadable-loading' >Loading...</div>
  }
})
const ClearoutOrgList = Loadable({
  loader: () => import(/* webpackChunkName: "ClearoutLists" */
    './components/clearout_organization_list/clearout_organization_list'),
  loading: function Loading() {
    return <div id='react-loadable' className='react-loadable-loading' >Loading...</div>
  }
})

const AbuseList = Loadable({
  loader: () => import('./components/abuse'),
  loading: () => null,
})
const CopAbuseList = Loadable({
  loader: () => import('./components/cop_abuse'),
  loading: () => null,
})


const SpokeslyUsersList = Loadable({
  loader: () => import('./components/spokesly_users'),
  loading: () => null,
})
const SpokeslyOrgList = Loadable({
  loader: () => import(/* webpackChunkName: "ClearoutLists" */
    './components/spokesly_clearout_organization_list/clearout_organization_list'),
  loading: function Loading() {
    return <div id='react-loadable' className='react-loadable-loading' >Loading...</div>
  }
})

const SpokeslyList = Loadable({
  loader: () => import('./components/spokesly_clearout_lists/myList'),
  loading: () => null,
})

const SpokeslyClearoutIndividualUserInfo = Loadable({
  loader: () => import('./components/spokesly_individual_user_info/spokesly_clearout_individual_user_info'),
  loading: () => null,
})

const SpokeslyDownload = Loadable({
  loader: () => import(/* webpackChunkName: "SpokeslyDownload" */
    './components/spokesly_download/download'),
  loading: function Loading() {
    return <div id='react-loadable' className='react-loadable-loading' >Downloading...</div>
  }
})

const SpokeslyDownloadWithoutPolling = Loadable({
  loader: () => import(/* webpackChunkName: "SpokeslyDownloadWithoutPolling" */
    './components/spokesly_download/downloadWithoutPolling'),
  loading: function Loading() {
    return <div id='react-loadable' className='react-loadable-loading' >Downloading...</div>
  }
})

const SpokeslyClearoutEmailFinderLists = Loadable({
  loader: () => import(/* webpackChunkName: "SpokeslyClearoutEmailFinderLists" */
    './components/spokesly_clearout_emailfinder_lists/myList'),
  loading: function Loading() {
    return <div id='react-loadable' className='react-loadable-loading' >Loading...</div>
  }
})
//
const ClearoutEUUsersList = Loadable({
  loader: () => import('./components/clearout_eu_users'),
  loading: () => null,
})

const ClearoutEUOrganizationInfo = Loadable({
  loader: () => import('./components/clearout_eu_individual_user_info/clearout_eu_organization_info'),
  loading: () => null,
})

const ClearoutEUOrgList = Loadable({
  loader: () => import(/* webpackChunkName: "ClearoutLists" */
    './components/clearout_eu_organization_list/clearout_organization_list'),
  loading: function Loading() {
    return <div id='react-loadable' className='react-loadable-loading' >Loading...</div>
  }
})

const ClearoutEUList = Loadable({
  loader: () => import('./components/clearout_eu_lists/myList'),
  loading: () => null,
})

const ClearoutEUIndividualUserActivity = Loadable({
  loader: () => import('./components/clearout_eu_individual_user_info/user_activity'),
  loading: () => null,
})

const ClearoutEUEmailFinderLists = Loadable({
  loader: () => import(/* webpackChunkName: "ClearoutEUEmailFinderLists" */
    './components/clearout_eu_emailfinder_lists/myList'),
  loading: function Loading() {
    return <div id='react-loadable' className='react-loadable-loading' >Loading...</div>
  }
})

const ClearoutEUClearoutIndividualUserInfo = Loadable({
  loader: () => import('./components/clearout_eu_individual_user_info/clearout_eu_individual_user_info'),
  loading: () => null,
})

const ClearoutEUDownload = Loadable({
  loader: () => import(/* webpackChunkName: "ClearoutEUDownload" */
    './components/clearout_eu_download/download'),
  loading: function Loading() {
    return <div id='react-loadable' className='react-loadable-loading' >Downloading...</div>
  }
})

const ClearoutEUDownloadWithoutPolling = Loadable({
  loader: () => import(/* webpackChunkName: "ClearoutEUDownloadWithoutPolling" */
    './components/clearout_eu_download/downloadWithoutPolling'),
  loading: function Loading() {
    return <div id='react-loadable' className='react-loadable-loading' >Downloading...</div>
  }
})

const ClearoutEPUsersList = Loadable({
  loader: () => import('./components/clearout_ep_users'),
  loading: () => null,
})

const ClearoutEPOrganizationInfo = Loadable({
  loader: () => import('./components/clearout_ep_individual_user_info/clearout_ep_organization_info'),
  loading: () => null,
})

const ClearoutEPOrgList = Loadable({
  loader: () => import(/* webpackChunkName: "ClearoutLists" */
    './components/clearout_ep_organization_list/clearout_organization_list'),
  loading: function Loading() {
    return <div id='react-loadable' className='react-loadable-loading' >Loading...</div>
  }
})

const ClearoutEPList = Loadable({
  loader: () => import('./components/clearout_ep_lists/myList'),
  loading: () => null,
})

const ClearoutEPIndividualUserActivity = Loadable({
  loader: () => import('./components/clearout_ep_individual_user_info/user_activity'),
  loading: () => null,
})

const ClearoutEPEmailFinderLists = Loadable({
  loader: () => import(/* webpackChunkName: "ClearoutEUEmailFinderLists" */
    './components/clearout_ep_emailfinder_lists/myList'),
  loading: function Loading() {
    return <div id='react-loadable' className='react-loadable-loading' >Loading...</div>
  }
})

const ClearoutEPClearoutIndividualUserInfo = Loadable({
  loader: () => import('./components/clearout_ep_individual_user_info/clearout_ep_individual_user_info'),
  loading: () => null,
})

const ClearoutEPDownload = Loadable({
  loader: () => import(/* webpackChunkName: "ClearoutEUDownload" */
    './components/clearout_ep_download/download'),
  loading: function Loading() {
    return <div id='react-loadable' className='react-loadable-loading' >Downloading...</div>
  }
})

const ClearoutEPDownloadWithoutPolling = Loadable({
  loader: () => import(/* webpackChunkName: "ClearoutEUDownloadWithoutPolling" */
    './components/clearout_ep_download/downloadWithoutPolling'),
  loading: function Loading() {
    return <div id='react-loadable' className='react-loadable-loading' >Downloading...</div>
  }
})

//
const ClearoutCouponList = Loadable({
  loader: () => import(/* webpackChunkName: "ClearoutCouponList" */
    './components/coupons'),
  loading: function Loading() {
    return <div id='react-loadable' className='react-loadable-loading' >Downloading...</div>
  }
})

const CopClearoutCouponList = Loadable({
  loader: () => import(/* webpackChunkName: "CopClearoutCouponList" */
    './components/cop_coupons'),
  loading: function Loading() {
    return <div id='react-loadable' className='react-loadable-loading' >Loading...</div>
  }
})

const ClearoutAbuseLogs = Loadable({
  loader: () => import('./components/abuse_logs'),
  loading: function Loading() {
    return <div id='react-loadable' className='react-loadable-loading' >Loading...</div>
  }
})

const ClearoutAbuseUpdateLogs = Loadable({
  loader: () => import('./components/abuse_logs/abuse_update_logs'),
  loading: function Loading() {
    return <div id='react-loadable' className='react-loadable-loading' >Loading...</div>
  }
})

const ClearoutProspectLists = Loadable({
  loader: () => import(/* webpackChunkName: "ClearoutProspectLists" */
    './components/clearout_prospect_lists/myList'),
  loading: function Loading() {
    return <div id='react-loadable' className='react-loadable-loading' >Loading...</div>
  }
})

const ClearoutProspectRequests = Loadable({
  loader: () => import(/* webpackChunkName: "ClearoutProspectRequests" */
    './components/clearout_prospect_requests/myRequests'),
  loading: function Loading() {
    return <div id='react-loadable' className='react-loadable-loading' >Loading...</div>
  }
})

const DownloadProspectList = Loadable({
  loader: () => import(/* webpackChunkName: "DownloadProspectList" */
    './components/download/prospect'),
  loading: function Loading() {
    return <div id='react-loadable' className='react-loadable-loading' >Downloading...</div>
  }
})

const loggerMiddleware = createLogger()

const enhancer = compose(
  // Middleware you want to use in development:
  // thunkMiddleware - lets us dispatch() functions
  // loggerMiddleware - neat middleware that logs actions
  // routingMiddleware - to capture dispatched actions created by the action creators
  applyMiddleware(thunkMiddleware, loggerMiddleware),
  DevTools.instrument()
)

const rootReducer = (state, action) => {
  return appReducer(state, action)
}

const persistedState = localStorage.getItem('sfAppState') ? JSON.parse(localStorage.getItem('sfAppState')) : {}
const store = createStore(rootReducer, persistedState, enhancer)

store.subscribe(() => {
  localStorage.setItem('sfAppState', JSON.stringify(store.getState()))
})

const userIsAuthenticated = connectedRouterRedirect({
  // The url to redirect user to if they fail
  redirectPath: '/login',
  // Determine if the user is authenticated or not
  authenticatedSelector: state => state.userReducer.isLogged === true,
  // A nice display name for this check
  wrapperDisplayName: 'UserIsAuthenticated'
})

const locationHelper = locationHelperBuilder({})

const userIsNotAuthenticated = connectedRouterRedirect({
  // This sends the user either to the query param route if we have one, or to the landing page if none is specified and the user is already logged in
  redirectPath: (state, ownProps) => locationHelper.getRedirectQueryParam(ownProps) || '/dashboard',
  // This prevents us from adding the query parameter when we send the user away from the login page
  allowRedirectBack: false,
  // Determine if the user is authenticated or not
  authenticatedSelector: state => state.userReducer.isLogged === false,
  // A nice display name for this check
  wrapperDisplayName: 'UserIsNotAuthenticated'
})

const DashboardParentComp = () => (
  <Dashboard>
    <Switch>
      <Route exact path='/dashboard'>
        <Redirect to='/dashboard/clearout_users' />
      </Route>
      <Route exact path='/dashboard/clearout_prospect'>
        <Redirect to='/dashboard/clearout_prospect/lists' />
      </Route>
      <Route path='/dashboard/live_chats' component={LiveChats} />
      <Route path='/dashboard/live_visitors' component={LiveVisitors} />
      <Route path='/dashboard/chat_reports' component={ChatReports} />
      <Route path='/dashboard/labs_users' component={LabsUsers} />
      <Route path='/dashboard/individual_user_info' component={individualUserInfo} />
      <Route path='/dashboard/clearout_individual_user_info' component={ClearoutIndividualUserInfo} />
      <Route path='/dashboard/cop_individual_user_info' component={CopIndividualUserInfo} />
      <Route path='/dashboard/clearout_individual_user_activity' component={ClearoutIndividualUserActivity} />
      <Route path='/dashboard/clearout_organization_info' component={ClearoutOrganizationInfo} />
      <Route path='/dashboard/spokesly_organization_info' component={SpokeslyOrganizationInfo} />
      <Route path='/dashboard/spokesly_clearout_org_list' component={SpokeslyOrgList} />
      <Route path='/dashboard/spokesly_clearout_individual_user_info' component={SpokeslyClearoutIndividualUserInfo} />
      <Route path='/dashboard/spokesly_individual_user_activity' component={SpokeslyIndividualUserActivity} />

      <Route path='/dashboard/kintegra_users' component={KintegraUsers} />
      <Route path='/dashboard/clearout_users' component={ClearoutUsersList} />
      <Route path='/dashboard/clearout/abuse_logs' component={ClearoutAbuseLogs} />
      <Route path='/dashboard/clearout/abuse_update_logs' component={ClearoutAbuseUpdateLogs} />
      <Route path='/dashboard/clearout_organization_users' component={ClearoutOrganizationUsersList} />
      <Route path='/dashboard/clearout_eu_organization_users' component={ClearoutEUOrganizationUsersList} />

      <Route path='/dashboard/clearout_ep_organization_users' component={ClearoutEPOrganizationUsersList} />

      <Route path='/dashboard/clearoutphone/users' component={ClearoutPhoneUsersList} />
      <Route path='/dashboard/clearout/coupons' exact component={ClearoutCouponList} />
      <Route path='/dashboard/clearout/coupons/:couponId' component={ClearoutCouponList} />
      <Route path='/dashboard/cop/coupons' exact component={CopClearoutCouponList} />
      <Route path='/dashboard/cop/coupons/:couponId' component={CopClearoutCouponList} />
      <Route path='/dashboard/cop_individual_user_activity' component={CopIndividualUserActivity} />
      <Route path='/dashboard/download_clearout_users' component={DownloadClearoutUsersList} />
      <Route path='/dashboard/download_clearoutphone_users' component={DownloadClearoutPhoneUsersList} />

      <Route path='/dashboard/spokesly_users' component={SpokeslyUsersList} />

      <Route path='/dashboard/request_list' component={RequestList} />

      <Route path='/dashboard/spokesly_list' component={SpokeslyList} />
      <Route path='/dashboard/spokesly_organization_users' component={SpokeslyOrganizationUsersList} />
      <Route path='/dashboard/clearout_lists' component={ClearoutLists} />
      <Route path='/dashboard/cop_lists' component={CopLists} />
      <Route path='/dashboard/clearout_org_list' component={ClearoutOrgList} />
      <Route path='/dashboard/clearout/abuse_list' component={AbuseList} />
      <Route path='/dashboard/cop/abuse_list' component={CopAbuseList} />
      <Route path='/dashboard/clearout_emailfinder_lists' component={ClearoutEmailFinderLists} />
      <Route path='/dashboard/clearout_eu_emailfinder_lists' component={ClearoutEUEmailFinderLists} />
      <Route path='/dashboard/clearout_ep_emailfinder_lists' component={ClearoutEPEmailFinderLists} />
      <Route path='/dashboard/spokesly_clearout_emailfinder_lists' component={SpokeslyClearoutEmailFinderLists} />
      <Route path='/dashboard/clearout_prospect/lists' component={ClearoutProspectLists} />
      <Route path='/dashboard/clearout_prospect/requests' component={ClearoutProspectRequests} />

      <Route path='/dashboard/clearout_eu_organization_info' component={ClearoutEUOrganizationInfo} />
      <Route path='/dashboard/clearout_eu_org_list' component={ClearoutEUOrgList} />
      <Route path='/dashboard/clearout_eu_individual_user_info' component={ClearoutEUClearoutIndividualUserInfo} />
      <Route path='/dashboard/clearout_eu_individual_user_activity' component={ClearoutEUIndividualUserActivity} />
      <Route path='/dashboard/clearout_eu_users' component={ClearoutEUUsersList} />
      <Route path='/dashboard/clearout_eu_list' component={ClearoutEUList} />

      <Route path='/dashboard/clearout_ep_organization_info' component={ClearoutEPOrganizationInfo} />
      <Route path='/dashboard/clearout_ep_org_list' component={ClearoutEPOrgList} />
      <Route path='/dashboard/clearout_ep_individual_user_info' component={ClearoutEPClearoutIndividualUserInfo} />
      <Route path='/dashboard/clearout_ep_individual_user_activity' component={ClearoutEPIndividualUserActivity} />
      <Route path='/dashboard/clearout_ep_users' component={ClearoutEPUsersList} />
      <Route path='/dashboard/clearout_ep_list' component={ClearoutEPList} />



    </Switch>
  </Dashboard>
)

const LoginAuthWrapper = userIsNotAuthenticated(Login)
const SignUpAuthWrapper = userIsNotAuthenticated(Signup)
const DashboardAuthWrapper = userIsAuthenticated(DashboardParentComp)

const App = () => (
  <Switch>
    <Route exact path='/'>
      <Redirect to="/dashboard" />
    </Route>
    <Route path='/login' component={LoginAuthWrapper} />
    <Route path='/signup' component={SignUpAuthWrapper} />
    <Route path='/dashboard' component={DashboardAuthWrapper} />
    <Route path='/ssologin' component={SsoLogin} />

    <Route path='/spokesly/download_result/:download_id' component={SpokeslyDownload} />
    <Route path='/spokesly/download/result/' component={SpokeslyDownloadWithoutPolling} />

    <Route path='/clearout_eu/download_result/:download_id' component={ClearoutEUDownload} />
    <Route path='/clearout_eu/download/result/' component={ClearoutEUDownloadWithoutPolling} />

    <Route path='/clearout_ep/download_result/:download_id' component={ClearoutEPDownload} />
    <Route path='/clearout_ep/download/result/' component={ClearoutEPDownloadWithoutPolling} />

    <Route path='/download_result/:download_id' component={Download} />
    <Route path='/download/result' component={DownloadWithoutPolling} />
    <Route path='/download/prospect' component={DownloadProspectList} />

    <Route path='/cop_download_result/:download_id' component={CopDownload} />
    <Route path='/cop_download/result' component={CopDownloadWithoutPolling} />

  </Switch>
)

ReactDOM.render(
  <Provider store={store} >
    <Router>
      <div>
        <Route path="/" component={App} />
      </div>
    </Router>
  </Provider>
  , document.getElementById('root'));

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js